function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import find from 'lodash/find';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as shapes from '../../shapes';
import messages from '../../messages';
import organizationLogoStyles from '../../OrganizationLogo.pcss';
var _React_PureComponent;
class OrganizationBox extends (_React_PureComponent = React.PureComponent) {
    onJoin() {
        if (!this.props.onJoin || this.props.isPlaceholder) {
            return;
        }
        const { organization } = this.props;
        this.props.onJoin(organization.organizationUID);
    }
    get country() {
        const { countryCode: alpha2Code } = this.props.organization;
        const country = find(this.props.countries, {
            alpha2Code
        });
        return country ? get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName) : alpha2Code;
    }
    renderImage() {
        const { organization, isPlaceholder } = this.props;
        const img = isPlaceholder ? /*#__PURE__*/ _jsx("div", {
            className: organizationLogoStyles.logo
        }) : /*#__PURE__*/ _jsx(Avatar, {
            name: organization.name,
            size: 48,
            avatarImg: organization.logo,
            className: organizationLogoStyles.logo
        });
        return /*#__PURE__*/ _jsx("figure", {
            className: "linkTile__image",
            children: img
        });
    }
    renderHeader() {
        const { organization, isPlaceholder } = this.props;
        if (isPlaceholder) {
            return /*#__PURE__*/ _jsx("div", {
                className: "linkTile__header w-75"
            });
        }
        return /*#__PURE__*/ _jsx("h3", {
            className: "linkTile__header",
            children: organization.name
        });
    }
    renderId() {
        const { organization, isPlaceholder } = this.props;
        if (isPlaceholder) {
            return /*#__PURE__*/ _jsx("p", {
                className: "linkTile__info w-50"
            });
        }
        return /*#__PURE__*/ _jsxs("p", {
            className: "linkTile__info",
            children: [
                "ID: ",
                organization.organizationUID
            ]
        });
    }
    renderInfo() {
        const { organization, isPlaceholder } = this.props;
        if (isPlaceholder) {
            return /*#__PURE__*/ _jsx("p", {
                className: "linkTile__info w-50"
            });
        }
        const { street, city, zipCode } = organization;
        return /*#__PURE__*/ _jsxs("p", {
            className: "linkTile__info",
            children: [
                this.country,
                ", ",
                street,
                ", ",
                city,
                " ",
                zipCode
            ]
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderHeader(),
                this.renderId(),
                this.renderInfo()
            ]
        });
    }
    renderButtons() {
        const { isPlaceholder } = this.props;
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: isPlaceholder ? 'placeholder' : 'primary',
            labelMessage: messages.buttons.joinOrganization,
            className: isPlaceholder ? '' : 'text--primary',
            onClick: ()=>this.onJoin()
        });
    }
    render() {
        const { isPlaceholder } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: cn('linkTile linkTile--border', this.props.className, {
                'linkTile--placeholder fadingLoader': isPlaceholder
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-auto",
                        children: this.renderImage()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col my-2 my-sm-0",
                        children: this.renderContent()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-auto text--right",
                        children: this.renderButtons()
                    })
                ]
            })
        });
    }
}
_define_property(OrganizationBox, "propTypes", {
    // Explicit props
    organization: shapes.organization,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isPlaceholder: PropTypes.bool,
    // Implicit props
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    // Explicit actions
    onJoin: PropTypes.func
});
_define_property(OrganizationBox, "defaultProps", {
    isPlaceholder: false
});
const mapStateToProps = (state)=>({
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const ConnectedOrganizationBox = connect(mapStateToProps)(OrganizationBox);
export default ConnectedOrganizationBox;
